import React from "react";
import Screens from "../../assets/screen-stack.png";

const SteamWordsSection = () => {
  return (
    <section className="bg-[#F5F5F5] py-10 sm:py-14 lg:pb-16 lg:pt-[90px]">
      <div className="mx-auto flex max-w-[1720px] flex-col items-center gap-8 px-4 sm:gap-10 sm:px-6 md:px-10 lg:flex-row lg:gap-12 xl:gap-20">
        <div className="w-full max-w-[756px] shrink-0">
          <img
            src={Screens}
            alt="STEAM Words game screens"
            className="h-auto w-full object-contain"
          />
        </div>

        <div className="w-full max-w-[760px] lg:pr-4">
          <span className="inline-flex bg-[#923D8C] px-3 py-2.5 text-xl font-bold leading-tight tracking-[1%] text-white sm:p-4 sm:text-3xl sm:leading-[26px] md:text-4xl">
            Steam Words Game
          </span>

          <p className="mt-6 text-justify text-base tracking-[1%] text-black sm:mt-8 sm:text-lg md:mt-10 md:text-xl">
            STEAM Words is an interactive, gamified crossword puzzle game
            designed for K-5 to K-12 students to build critical thinking, STEM
            vocabulary, and cognitive associations in a fun and engaging format.
            Students form words related to STEAM, which unlock levels and
            mini-challenges. Each puzzle is aligned with educational standards
            and mapped to STEAM subjects, enabling integrated learning.
          </p>

          <div className="mt-5 leading-7 tracking-[1%] text-black">
            <h3 className="text-xl font-bold sm:text-2xl">Key Features:</h3>
            <ol className="mt-3 list-decimal space-y-1 pl-5 text-base sm:mt-5 sm:pl-6 sm:text-lg md:text-xl">
              <li>Unlimited word formation for STEM vocabulary</li>
              <li>Hints and feedback to guide learning</li>
              <li>Leaderboards and achievements</li>
              <li>Multi-device compatibility</li>
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SteamWordsSection;
